import axios from "axios";
import { toast } from "sonner";
import { clearUserToken, getUserToken } from "./userApi";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Public axios instance for client-portal endpoints (no auth cookie).
export const apiPublic = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 120000,
});

api.interceptors.request.use((config) => {
  const t = getUserToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

function handle401(err) {
  const detail = err.response?.data?.detail;
  const code = (detail && typeof detail === "object" && detail.code) || "";
  if (code === "session_evicted" || code === "session_invalid") {
    toast.error(
      detail.message || "تَمَّ تَسجيل خُروجِك. سَجِّل دُخولك مَرَّة أُخرى.",
      { id: "auth-session-evicted", duration: 6000 },
    );
  }
  clearUserToken();
  const path = window.location.pathname;
  const publicPaths = ["/", "/login", "/signup", "/laws", "/courts", "/cassation", "/admin"];
  if (!publicPaths.some((p) => path === p || path.startsWith(p + "/"))) {
    window.location.href = "/login";
  }
}

function handle402(err) {
  const detail = err.response?.data?.detail;
  if (detail && typeof detail === "object" && detail.code) {
    try { window.dispatchEvent(new CustomEvent("paywall:show", { detail })); }
    catch { /* CustomEvent unavailable in legacy runtimes — silent fallback */ }
  } else if (typeof detail === "string") {
    toast.error(detail, { id: "auth-payment-required" });
  }
}

function handle403(err) {
  // Surface backend Arabic error strings instead of the raw axios stack
  // so users see WHY a request was denied (membership drift, revoked
  // role, expired subscription grace, etc.). Never navigates — 403 is
  // permission, not identity, and forcing /login would be wrong.
  const detail = err.response?.data?.detail;
  const message = typeof detail === "string"
    ? detail
    : (detail && detail.message) || "لَيس لَدَيك صَلاحيَّة لِهَذِه العَمَلِيَّة.";
  toast.error(message, { id: "auth-forbidden" });
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) handle401(err);
    if (err?.response?.status === 402) handle402(err);
    if (err?.response?.status === 403) handle403(err);
    return Promise.reject(err);
  },
);

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
